module.exports = __webpack_public_path__ + "static/media/hanssoni.5681aeed.png";